import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import Pagination from "react-js-pagination";
import { Url } from "../../config/config";
import Modal from "react-bootstrap/Modal";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import useDebounce from "../../hooks/useDebounce";


export default function BusinessNature() {
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [record, setRecord] = useState([]);
  const [total, setTotal] = useState(0);
  const [activePage, setActivePage] = useState(1);

  const [searchValue, setSearchValue] = useState("");
  const debounceValue = useDebounce(searchValue, 500);

  const [inputField, setInputField] = useState({
    id: "",
    financialPartnerName: "",
    status: "1",
  });

  const [errorField, setErrorField] = useState({
    financialPartnerName: "",
  });

  //handele delete
  const [DeleteModal, setDeleteModal] = useState(false);
  const handelDeleteShow = (id) => {
    //console.log(id);
    setDeleteModal(true);
    setInputField({ ...inputField, id: id });
  };
  const handelDeleteClose = () => {
    setDeleteModal(false);
  };

  const handelDelete = async () => {
    try {
      const res = await axios({
        url: `${Url}/business_nature?natureId=${inputField.id}`,
        method: "DELETE",
      });
      if (res.data.status === 200) {
        handelDeleteClose();
        toast.success(res.data.message);
        businessList();
      } else {
        toast.error("Something went to wrong");
      }
    } catch (err) {
      console.log(err);
    }
  };

  ////////////////handele Block popup////////////////////
  const [BlockModal, setBlockModal] = useState(false);
  const handelBlockShow = () => {
    setBlockModal(true);
  };

  const handelBlockClose = () => {
    setBlockModal(false);
  };
  const handleChecked = (e, id) => {
    handelBlockShow();
    setInputField({
      ...inputField,
      status: e.target.checked,
      id: id,
    });
  };

  const handelUpdateStatus = async () => {
    try {
      const res = await axios({
        url: `${Url}/business_nature/status`,
        method: "POST",
        data: {
          natureId: inputField.id,
          status: inputField.status,
        },
      });
      console.log(res.data.status);
      if (res.data.status === 200) {
        handelBlockClose();
        toast.success(res.data.message);
        businessList();
      } else {
        toast.error("Something went to wrong");
      }
    } catch (err) {
      console.log(err);
    }
  };

  ///////////////handel Add popup ////////////////////////////////////
  const [AddModal, setAddModal] = useState(false);
  const handelAddModalShow = () => {
    setInputField("");
    setErrorField("");
    setAddModal(true);
  };

  const handelAddModalClose = () => {
    setAddModal(false);
  };

  const handleInputChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    console.log("input handler", name, "     ", value);
    setInputField({
      ...inputField,
      [name]: value,
    });
  };

  //handel validate
  const handleValidation = () => {
    let errorField = {};
    let formIsValid = true;
    if (!inputField.financialPartnerName) {
      errorField["financialPartnerName"] = "Business name field is required";
      formIsValid = false;
    }
    setErrorField(errorField);
    return formIsValid;
  };

  const handelSubmit = async () => {
    try {
      if (handleValidation()) {
        let res = await axios({
          url: `${Url}/business_nature`,
          method: "POST",
          headers: {
            //  Authorization: "Bearer " + accessToken,
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
          data: { financialPartnerName: inputField.financialPartnerName },
        });
        if (res.data.status === 200) {
          handelAddModalClose();
          setInputField("");
          setErrorField("");
          businessList();
          toast.success(res.data.message);
        } else if (res.data.status === 419) {
          toast.error(res.data.message);
        } else {
          toast.error("Something went to wrong");
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  //////////////edit business////////////////
  const [EditModal, setEditModal] = useState(false);
  const handelEditModalClose = () => {
    setEditModal(false);
  };
  const handelEditModalShow = (data) => {
    setEditModal(true);
    setInputField({
      ...inputField,
      id: data._id,
      financialPartnerName: data.financialPartnerName,
    });
  };
  const handelEditSubmit = async () => {
    try {
      const res = await axios({
        url: `${Url}/business_nature`,
        method: "PUT",
        headers: {
          //Authorization: "Bearer " + accessToken,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        data: {
          natureId: inputField.id,
          financialPartnerName: inputField.financialPartnerName,
        },
      });
      if (res.data.status === 200) {
        handelEditModalClose();
        setInputField("");
        setErrorField("");
        businessList();
        toast.success(res.data.message);
      } else if (res.data.status === 419) {
        toast.error(res.data.message);
      } else {
        toast.error("Something went to wrong");
      }
    } catch (err) {
      console.log(err);
    }
  };

  const businessList = async (query = "") => {
    try {
      showLoader();
      const page = 1;
      const res = await axios({
        url: `${Url}/business_nature?search=${query}`,
        method: "GET",
        headers: {
          //Authorization: "Bearer " + accessToken,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      hideLoader();
      if (res.data.status === 200) {
        //console.log(res.data.data.natureList);
        setRecord(res.data.data.natureList);
        setTotal(res.data.data.total);
      }
    } catch (err) {
      console.log(err);
    }
    // console.log(res.data.result);
  };

  useEffect(() => {
    businessList(debounceValue);
  }, [debounceValue]);

  //////////////handel search//////////
  const handelSearch = (e) => {
    //setSearch(e.target.value);
    setSearchValue(e.target.value);
    // console.log(e.target.value);
  };

  return (
    <React.Fragment>
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="SearchBox">
              <input
                type="text"
                placeholder="Search .."
                onChange={handelSearch}
              />

              <button type="button" className="button py-auto" onClick={handelAddModalShow}>
                Add&nbsp;Document
              </button>
            </div>
            <h4 className="Title">Business Nature Management</h4>
            <div className="TableList">
              {loader}
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Financial Partner Name</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {record &&
                    record.length > 0 &&
                    record.map((item, i) => (
                      <tr key={i}>
                        <td>{++i}</td>

                        <td>{item.financialPartnerName}</td>
                        <td>
                          <div className="form-check form-switch">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              name="status"
                              checked={item.status}
                              onChange={(e) => handleChecked(e, item._id)}
                            />
                            <label className="form-check-label"></label>
                          </div>
                        </td>
                        <td>
                          <span
                            className="Green inline-block"
                            onClick={(e) => handelEditModalShow(item)}
                          >
                            <i className="fa fa-edit"></i>
                          </span>

                          <span
                            className="Red inline-block"
                            onClick={(e) => handelDeleteShow(item._id)}
                          >
                            <i className="fa fa-trash"></i>
                          </span>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>

            {/* <div className="Pagination">
              <Pagination
                activePage={activePage}
                previousLabel={"previous"}
                nextLabel={"next"}
                itemsCountPerPage={10}
                totalItemsCount={total}
                pageRangeDisplayed={5}
                onChange={handlePageChange}
              />
            </div> */}
          </div>
        </div>
      </div>

      <div className="ModalBox">
        {/* Add modal */}
        <Modal className="admin_modal"
          show={AddModal}
          onHide={handelAddModalClose}
        >
          <Modal.Header closeButton onClick={handelAddModalClose}>
            <Modal.Title>Add New Nature of Business</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form method="POST">
              <div className="form-group">
                <label>Name </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Business Name"
                  name="financialPartnerName"
                  value={inputField.financialPartnerName}
                  onChange={handleInputChange}
                />
                <span style={{ color: "red" }} className="error">
                  {errorField.financialPartnerName}
                </span>
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <button variant="secondary" onClick={handelAddModalClose}>
              Close
            </button>
            <button variant="primary" onClick={handelSubmit}>
              Submit
            </button>
          </Modal.Footer>
        </Modal>
        {/* End add Modal */}

        {/* Edit modal */}
        <Modal
          show={EditModal}

          onHide={handelEditModalClose}
        >
          <Modal.Header closeButton onClick={handelEditModalClose}>
            <Modal.Title>Edit Nature of Business</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form method="POST">
              <div className="form-group">
                <label>Name </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter Business Name"
                  name="financialPartnerName"
                  value={inputField.financialPartnerName}
                  onChange={handleInputChange}
                />
                <span style={{ color: "red" }} className="error">
                  {errorField.financialPartnerName}
                </span>
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
            {/* <button variant="secondary" onClick={handelEditModalClose}>
              Close
            </button> */}
            <button className="primary" variant="primary" onClick={handelEditSubmit}>
              Save
            </button>
          </Modal.Footer>
        </Modal>
        {/* End edit Modal */}

        {/* Start Delete Modal */}
        <Modal
          show={DeleteModal}

          onHide={handelDeleteClose}
        >
          <Modal.Header closeButton onClick={handelDeleteClose}>
            <Modal.Title>Delete</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure want to delete this business name?
          </Modal.Body>
          <Modal.Footer>
            <button className="secondary" variant="secondary" onClick={handelDeleteClose}>
              No
            </button>
            <button className="primary" variant="primary" onClick={handelDelete}>
              Yes
            </button>
          </Modal.Footer>
        </Modal>
        {/* End delete Modal */}

        {/* block or unblock model */}
        <Modal
          show={BlockModal}

          onHide={handelBlockClose}
        >
          <Modal.Header closeButton onClick={handelBlockClose}>
            <Modal.Title>Change Status</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure want to change the status?</Modal.Body>
          <Modal.Footer>
            <button className="secondary" variant="secondary" onClick={handelBlockClose}>
              No
            </button>
            <button className="primary" variant="primary" onClick={handelUpdateStatus}>
              Yes
            </button>
          </Modal.Footer>
        </Modal>
        {/* end block unblock modal */}
      </div>
    </React.Fragment>
  );
}
